import {
  type CreateFunnelReq,
  type CreateFunnelRes,
  type MoveFunnelReq,
  type MoveFunnelRes,
  type RecheckRes,
  type RetryFunnelRes,
  type SaveFunnelReq,
  type SaveFunnelRes,
  createFunnelReqSchema,
  moveFunnelReqSchema,
  recheckReqSchema,
  retryFunnelReqSchema,
  saveFunnelReqSchema,
} from '../entity/api/routes/article-funnel';
import { apiRequest } from './request';

export async function createArticleFunnel(id: CreateFunnelReq['params']['id']) {
  const req = createFunnelReqSchema.parse({
    params: { id },
    query: null,
    body: null,
  });
  return apiRequest<CreateFunnelRes>(`/article/${req.params.id}/funnel`, 'POST', true, null);
}

export async function setArticleFunnel(
  id: MoveFunnelReq['params']['id'],
  data: MoveFunnelReq['body']
) {
  const req = moveFunnelReqSchema.parse({
    params: { id },
    query: null,
    body: data,
  });
  return apiRequest<MoveFunnelRes>(`/article/${req.params.id}/funnel`, 'POST', true, req.body);
}

export async function saveArticleFunnel(
  id: SaveFunnelReq['params']['id'],
  startNextStepGeneration: SaveFunnelReq['body']['startNextStepGeneration'],
  data: SaveFunnelReq['body']['contentFunnelData']
) {
  const req = saveFunnelReqSchema.parse({
    params: { id },
    query: null,
    body: {
      contentFunnelData: data,
      startNextStepGeneration,
    },
  });
  return apiRequest<SaveFunnelRes>(`/article/${req.params.id}/funnel`, 'PATCH', true, req.body);
}

export async function retryArticleFunnelById(contentId: string) {
  const req = retryFunnelReqSchema.parse({
    params: { id: contentId },
    query: null,
    body: null,
  });
  return apiRequest<RetryFunnelRes>(
    `/article/${req.params.id}/funnel/retry`,
    'POST',
    true,
    req.body
  );
}

export async function recheckArticleJobsById(contentId: string) {
  const req = recheckReqSchema.parse({
    params: { id: contentId },
    query: null,
    body: null,
  });
  return apiRequest<RecheckRes>(`/article/${req.params.id}/funnel/recheck`, 'POST', true, req.body);
}
